import React from 'react'

const Footer = () => {
    return (
        <div>
            <p>Hello from footer</p>
        </div>
    )
}

export default Footer
